import { extendedRetry } from "@/utils/extended-retry";
import axios from "@/axios";
import { universalStorage } from "@/utils/universal-storage";
import { EventMap, eventMetadata, Events } from "./consts";
import { logger } from "@/services/logger";

interface ParsedEvent {
  event_name: string;
  event_group: string;
  user_id?: string;
  lead_id?: string;
  data: Record<string, unknown>;
}

class FunnelService {
  public async trackEvent<EventKey extends Events>(eventName: EventKey, payload?: EventMap[EventKey]) {
    const parsedEvent = this.parseEvent(eventName, payload as Record<string, unknown>);

    try {
      await extendedRetry(
        async () => {
          await axios.post(`analytics/publish_event`, parsedEvent);
        },
        {
          retries: 10,
          attemptTimeout: () => 5 * 1000,
          logger: (msg) => logger.warn(`Funnel event v2 - trackEvent retry ${msg}`),
        }
      );

      logger.info(`Funnel event v2 - ${eventName}`, { funnelEvent: parsedEvent });
    } catch (e) {
      logger.error(`Funnel event v2 report failed - ${eventName}`, { funnelEvent: payload, e });
    }
  }

  private parseEvent<EventKey extends Events>(eventName: EventKey, payload: Record<string, unknown> = {}): ParsedEvent {
    const sharedStorage = universalStorage.getAll();

    const parsedEvent: ParsedEvent = {
      event_name: eventName,
      user_id: sharedStorage.user_id,
      lead_id: sharedStorage.leadid,
      event_group: eventMetadata[eventName].eventGroup,
      data: {
        ...sharedStorage,
        ...payload,
        sent_from: "account_pages",
      },
    };
    return parsedEvent;
  }
}

export const funnelService = new FunnelService();
export * from "./consts";
